// extracted by mini-css-extract-plugin
export default {"inputWrapper":"style_inputWrapper__c7+BV","input":"style_input__89y2Q","search":"style_search__Xrg1G"};